function inputTime(id) {
  if (id.length) {
    id.mask('99:99', {placeholder:"чч.мм"});
  }
}
